/**
 * Nara: auto-select the compatible thread ("Filet") when a needle size ("Mărime")
 * is picked on interchangeable-tip products (Seeknit Koshitsu).
 *
 * Rule: sizes 2.0–3.0 mm use filet M1.8, sizes 3.5 mm and up use filet M2.
 * We flip the correct filet radio in the CAPTURE phase, before the theme's own
 * variant-picker `change` handler reads the checked options and fetches the
 * matching variant — so a single request lands on a valid combination.
 */
(function () {
  'use strict';

  const THREAD_VALUES = ['M1.8', 'M2'];
  const THRESHOLD = 3.5; // mm: >= this uses M2, below uses M1.8

  /** @param {HTMLInputElement} radio */
  const isThread = (radio) => THREAD_VALUES.includes((radio.value || '').trim());

  /** @param {Element} picker */
  function bind(picker) {
    if (picker.dataset.naraAutoThread === 'true') return;

    const threadRadios = Array.from(picker.querySelectorAll('input[type="radio"]')).filter(isThread);
    if (threadRadios.length < 2) return; // not an interchangeable-tip product

    picker.dataset.naraAutoThread = 'true';

    // Capture phase → runs before variant-picker's own bubble-phase handler.
    picker.addEventListener(
      'change',
      (event) => {
        const radio = event.target;
        if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
        if (isThread(radio)) return; // user picked a filet directly — leave it alone

        // A size radio changed. Parse the numeric mm value ("2.0 mm", "2,5 mm", "3").
        const mm = parseFloat(String(radio.value).replace(',', '.'));
        if (Number.isNaN(mm)) return;

        const desired = mm >= THRESHOLD ? 'M2' : 'M1.8';

        // Re-query live (radios get morphed on each variant change).
        const threads = Array.from(picker.querySelectorAll('input[type="radio"]')).filter(isThread);
        const target = threads.find((r) => (r.value || '').trim() === desired);
        if (!target || target.checked) return;

        // Native radio-group behaviour unchecks the sibling; we also mirror the
        // theme's data-current-checked flags so the pill highlight is correct
        // immediately (the server morph reconciles the rest afterwards).
        threads.forEach((r) => {
          r.dataset.previousChecked = r.checked ? 'true' : 'false';
          r.dataset.currentChecked = r === target ? 'true' : 'false';
        });
        target.checked = true;
      },
      true
    );
  }

  function init() {
    document.querySelectorAll('variant-picker').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
